export default __webpack_public_path__ + "static/media/PTX-2019-Event-Pic.d0b21036.png";